import CodeForm from './CodeForm'

function CodeWordInfo(codeType) {
  if (codeType.codeType === 'PAT') {
    return (
      <div>
        <br /><br /><br />
        <p>The Out Code/In Code for Mazda's newer vehicles have a total of 32 characters and you will see two 16-character sequences. When entering the Out Code, you will enter the two 16-character sequences as one 32-character sequence and when retrieving the In Code, you will receive a 32-character sequence that will need to be split into the two 16-character sequences for MDARS input. </p>
        <img src="/static/images/mdars.jpg" />
      </div>
    )
  } else {
    return (
      <div>&nbsp;</div>
    )
  }
}

let content

const PATSValidSubscription = ({ t, setCodeType, codeType, user, handleResetForm }) => (
  <div className="content m-t-lg">
    <div className="columns">
      <div className="column is-6">
        <div className="m-b-md">
          {codeType ? (content = <CodeWordInfo codeType={codeType} /> ,
            <CodeForm setCodeType={setCodeType} codeType={codeType} handleResetForm={handleResetForm} t={t} />
          ) : (content = <CodeWordInfo codeType={codeType} /> ,
            <div>
              <div className="m-b-sm">{t('common:pats-page-content-16')}</div>
              <button className="button is-default is-fullwidth m-b-md" onClick={() => setCodeType('Immob')}>
                {t('common:pats-page-content-11')}
              </button>
              <div className="m-b-sm">&nbsp;</div>
              <div className="m-b-sm">&nbsp;</div>
              <div className="m-b-sm">{t('common:pats-page-content-17')}</div>
              <button className="button is-default is-fullwidth m-b-md" onClick={() => setCodeType('PAT')}>
                {t('common:pats-page-content-12')}
              </button>
            </div>
          ) }
        </div>
      </div>
      <div className="column">
        <div className="m-b-sm">{t('common:pats-page-content-6')}</div>
        <div className="m-b-sm">{t('common:pats-page-content-7')}</div>
        <div className="m-b-sm">{t('common:pats-page-content-8')}</div>
        <div className="m-b-sm">{t('common:pats-page-content-9')}</div>
        <div>Name: <strong>{`${user.first_name} ${user.last_name}`}</strong></div>
        <div>Email: <strong>{user.username}</strong></div>
        <div className="m-b-sm" >{content}</div>
      </div>
    </div>
  </div>
)

export default PATSValidSubscription



// WEBPACK FOOTER //
// ./components/PATSCodes/WithValidSubscription.js